import React, { Component } from 'react';

/*
    menu definitions
*/
import {connect} from 'react-redux';
import ApplicationLoader from 'components/loaders/ApplicationLoader';

/*
    theme styles and layout - material admin
*/
import Header from './layout/Header';
import LeftDrawerList from './layout/LeftDrawerList';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import withWidth, {LARGE, SMALL} from 'material-ui/utils/withWidth';
import ThemeDefault from 'layouts/material-admin/theme-default';
import { getTranslate } from 'react-localize-redux';

/*
    in questo esempio App sarà la master page e le pagine child verranno iniettate
    in {this.props.children} sotto Header...
*/

console.log("App starting");

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          navDrawerOpen: false
        };
        this.handleChangeRequestNavDrawer = this.handleChangeRequestNavDrawer.bind(this);
      }

    componentWillReceiveProps(nextProps) {
        if (this.props.width !== nextProps.width) {
          this.setState({navDrawerOpen: nextProps.width === LARGE});
        }
    }

    handleChangeRequestNavDrawer() {
        this.setState({
          navDrawerOpen: !this.state.navDrawerOpen
        });
    }

    render() {
        let { navDrawerOpen } = this.state;
        /*
            se si modifica paddingLeftDrawerOpen bisogna modificare anche
            il theme-default - drawer width
        */
        const paddingLeftDrawerOpen = 256;

        const styles = {
            header: {
              paddingLeft: navDrawerOpen ? paddingLeftDrawerOpen : 0
            },
            container: {
              margin: '70px 20px 20px 5px',
              paddingLeft: navDrawerOpen && this.props.width !== SMALL ? paddingLeftDrawerOpen : 0,
              height: 'calc(100% - 10px)'
            },
            siteContainer:{
                height: 'calc(100% - 10px)'
            }

        };

        return (
            <MuiThemeProvider muiTheme={ThemeDefault}>
                {
                    this.props.user.isAuthenticating ?
                        <ApplicationLoader />
                    :
                    <div style={styles.siteContainer} >
                        <Header styles={styles.header}
                            handleChangeRequestNavDrawer={this.handleChangeRequestNavDrawer.bind(this)}/>

                        <LeftDrawerList
                            navDrawerOpen={navDrawerOpen} />

                        <div style={styles.container}>
                            {this.props.children}
                        </div>
                    </div>
                }

            </MuiThemeProvider>
        );
    }
}

/*
    i children sono proprietà richieste dal chiamante, infatti finiranno nel div del render
*/

function mapStateToProps(state, ownProps){
    return {
      user: {
        isAuthenticating: state.user.isAuthenticating,
        translate: getTranslate(state.locale)
      }
    }
  }

export default withWidth()(connect(mapStateToProps, null)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js